import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/* shadcn 규약의 클래스 합치기 — 생성된 ui/* 컴포넌트가 전부 이걸 부른다.
   clsx 가 조건부 클래스를 걸러내고, tailwind-merge 가 같은 축이 겹쳤을 때
   (px-2 와 px-0, text-xs 와 text-[11.5px]) 뒤에 온 쪽을 이기게 한다.
   단순 문자열 이어붙이기로는 앞의 px-2 가 살아남아 호출부의 override 가 먹지 않는다. */
export const cn = (...parts) => twMerge(clsx(parts));

export const todayISO = () => new Date().toISOString().slice(0, 10);

export function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371000, rad = Math.PI / 180;
  const dp = (lat2 - lat1) * rad, dl = (lng2 - lng1) * rad;
  const a = Math.sin(dp / 2) ** 2 +
    Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dl / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/* 신규·휴무는 데이터 필드가 아니라 **어느 파일에서 왔느냐**다 — new_stores.json 이면
   신규, closed_stores.json 이면 휴무. App 이 읽어 들이면서 _new / _closed 를 붙인다
   (_dist 처럼 밑줄은 '파일에 없고 화면이 붙인 것'이라는 표시).
   예전엔 added_at 날짜로 7일을 셌는데, 이제 신규를 떼는 건 파일을 옮기는 사람의 일이다. */
export const isNew = (store) => !!store?._new;
export const isClosed = (store) => !!store?._closed;

export const fmtDist = (m) => (m < 1000 ? `${Math.round(m)}m` : `${(m / 1000).toFixed(1)}km`);
export const fmtWon = (n) => `${Number(n).toLocaleString("ko-KR")}원`;
